import { Link } from 'lucide-react'
import { toast } from 'sonner'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

/**
 * Toolbar button (super-admin) that copies the current filtered-view URL.
 * Styled to match the data-table Reset button, with a tooltip on the same side.
 */
export function CallLogsCopyFilterButton() {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            onClick={() => {
              if (!navigator.clipboard) {
                toast.error('Failed to copy link')
                return
              }
              navigator.clipboard.writeText(window.location.href).then(
                () => toast.success('Filtered view link copied'),
                () => toast.error('Failed to copy link')
              )
            }}>
            <Link className="mr-2 h-4 w-4" />
            Copy filter
          </Button>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>Copy a shareable link to this filtered view</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
